// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1aEtz{display:-ms-flexbox;display:flex;-ms-flex-align:end;align-items:flex-end;margin-top:1.5rem;font-size:24px;font-size:1.5rem;font-weight:500;line-height:30px;line-height:1.875rem;font-family:var(--heading-font);letter-spacing:var(--letter-spacing)}@media(max-width:767px){._1aEtz{font-size:1.25rem;line-height:1.5625rem}}._1AFXX{margin-left:.5rem;color:#595757;line-height:2;font-size:14px;font-size:.875rem;font-weight:300;line-height:23px;line-height:1.4375rem;font-family:var(--base-font)}@media(max-width:767px){._1AFXX{font-size:1rem;line-height:1.625rem}}", ""]);
// Exports
exports.locals = {
	"price": "_1aEtz",
	"originalPrice": "_1AFXX"
};
module.exports = exports;
